export const SET_ELEMENT_PARTY = 'SET_ELEMENT_PARTY';